import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_support-sales-portal/artifacts/gesk70fc_Zeefa%20Logo.webp";

const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}?auth=${localStorage.getItem("zeefa_token") || ""}` : null);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("zeefa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
